var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-form-group",
    {
      attrs: {
        label: "Discount Code:",
        "label-cols-sm": "6",
        "label-align-sm": "right",
        state: _vm.valid,
        "invalid-feedback": "Invalid discount code.",
      },
    },
    [
      _c(
        "b-input-group",
        [
          _c("b-form-input", {
            attrs: { placeholder: "Voucher Code" },
            model: {
              value: _vm.discountCode,
              callback: function ($$v) {
                _vm.discountCode = $$v
              },
              expression: "discountCode",
            },
          }),
          _c(
            "b-input-group-append",
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "brand" },
                  on: { click: _vm.applyDiscountCode },
                },
                [_vm._v("Apply Discount")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }